// CANONICAL COPY (GH #7115). src/constants/obligations/obl-equipment-maintenance.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-equipment-maintenance',
  title: 'Verify equipment maintenance programme',
  description:
    'Confirm that equipment is correctly maintained to ensure continued availability, integrity and confidentiality of information. Maintenance shall follow supplier-recommended intervals, be performed only by authorised personnel, be preceded by removal or masking of sensitive information where equipment is sent off-site, and be recorded with faults observed and corrective action taken. Review the equipment maintenance standard and maintenance records for critical assets.',
  category: 'assets',
  scfIds: ['SCF-PHY-013'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Equipment maintenance standard is published' },
    { type: 'document-within-sla', description: 'Standard review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
